import _isEmpty from 'lodash/isEmpty'
import _isString from 'lodash/isString'

export default {
  between (value, args) {
    // 默认校验提示内容
    let msg = '数值必须在 {{ min }} - {{ max }}范围内!'
    // 校验规则,校验通过返回true,校验失败返回false
    let valid = Number(args.min) <= value && Number(args.max) >= value

    return {valid, msg}
  },
  required (value) {
    let msg = '不能为空!'

    if (value !== null && value !== undefined) {
      value = value.toString()
    }

    if (_isString(value)) {
      value = value.trim()
    }
    return {valid: !_isEmpty(value), msg}
  },
  RegExp (value, regExp) {
    let msg = '您输入的值不符合规则!'
    if (regExp && value) {
      value = new RegExp(regExp).test(value)
    } else if (!value) {
      value = true
    }
    return {valid: value, msg}
  },
  IDCard (value) {
    let msg = '身份证不合法!'
    let city = [
      '11', '12', '13', '14', '15',
      '21', '22', '23',
      '31', '32', '33', '34', '35', '36', '37',
      '41', '42', '43', '44', '45', '46',
      '50', '51', '52', '53', '54',
      '61', '62', '63', '64', '65',
      '71',
      '81', '82',
      '91']
    if (value.length === 18) {
      const PRODUCT = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      const CHECK_CODE = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
      let idCard = value.toUpperCase().split('')
      let checkNum = 0
      for (let i = 0; i < 17; i++) {
        checkNum += parseInt(idCard[i]) * PRODUCT[i]
      }
      if (idCard[17] === CHECK_CODE[checkNum % 11] && city.includes(value.substring(0, 2))) {
        value = true
      } else {
        value = false
      }
    } else {
      value = false
    }
    return {valid: value, msg}
  }
}
